import React, { useState } from 'react';
import { FaYoutube } from 'react-icons/fa';
import contactImage from '../assets/contact.webp';

const Contact = () => {
  const [formStatus, setFormStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    
    const formData = new FormData(form);

    const response = await fetch('https://formspree.io/f/mldennql', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    });

    if (response.ok) {
      setFormStatus('Thank you! Your message has been sent.');
      form.reset();
    } else {
      setFormStatus('Oops! Something went wrong. Please try again.');
    }
  };

  return (
    <section
      id="contact"
      className="min-h-screen flex items-start bg-cover bg-center relative"
      style={{ backgroundImage: `url(${contactImage})` }}
    >
      {/* Directional Vignette Effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/90 via-black/70 to-transparent"></div>

      {/* Contact Content */}
      <div className="relative z-10 pt-16 sm:pt-16 md:pt-16 pl-4 sm:pl-8 md:pl-10 lg:pl-16 text-white max-w-xs sm:max-w-md md:max-w-lg">
        <h2
          className="text-3xl sm:text-4xl md:text-4xl leading-tight drop-shadow-lg"
          style={{
            fontFamily: "'EB Garamond', serif",
            fontWeight: 500,
            letterSpacing: '0.05em',
            color: 'rgba(247, 246, 239, 0.85)',
          }}
        >
          CONTACT
        </h2>
        <div className="mt-4 text-lg leading-relaxed font-serif" style={{ fontFamily: "'EB Garamond', serif" }}>
          <p>For all general enquiries, please fill out the form below:</p>
        </div>

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
          <label className="block">
            <span className="text-gray-300" style={{ fontFamily: "'EB Garamond', serif" }}>Name:</span>
            <input
              type="text"
              name="name"
              required
              className="w-full p-2 mt-1 bg-[#333333] border border-[#4a4a4a] rounded focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-[#666666]"
              style={{ fontFamily: "'EB Garamond', serif" }}
            />
          </label>

          <label className="block">
            <span className="text-gray-300" style={{ fontFamily: "'EB Garamond', serif" }}>Email:</span>
            <input
              type="email"
              name="email"
              required
              className="w-full p-2 mt-1 bg-[#333333] border border-[#4a4a4a] rounded focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-[#666666]"
              style={{ fontFamily: "'EB Garamond', serif" }}
            />
          </label>

          <label className="block">
            <span className="text-gray-300" style={{ fontFamily: "'EB Garamond', serif" }}>Message:</span>
            <textarea
              name="message"
              rows="4"
              required
              className="w-full p-2 mt-1 bg-[#333333] border border-[#4a4a4a] rounded focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-[#666666]"
              style={{ fontFamily: "'EB Garamond', serif" }}
            />
          </label>

          {/* Submit Button */}
          <button
            type="submit"
            className="bg-[#4a4a4a] hover:bg-[#5a5a5a] text-white py-2 px-4 rounded mt-4 focus:outline-none focus:ring-1 focus:ring-gray-400"
            style={{ fontFamily: "'EB Garamond', serif", fontSize: '0.9rem' }}
          >
            Send Message
          </button>

          {/* Plain Success/Error Message */}
          {formStatus && (
            <p className="mt-4" style={{ fontFamily: "'EB Garamond', serif", color: 'rgba(247, 246, 239, 0.85)' }}>
              {formStatus}
            </p>
          )}
        </form>

        {/* YouTube Link */}
        <div className="flex items-center mt-8 mb-8 text-xl font-semibold">
          <FaYoutube className="h-8 w-8 mr-3" style={{ color: 'rgba(247, 246, 239, 0.85)' }} />
          <a
            href="https://www.youtube.com/@Sallyheath"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:underline"
            style={{ fontFamily: "'EB Garamond', serif" }}
          >
            @Sallyheath
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
